import { Component, OnInit } from '@angular/core';
import { QuotationHistoryService } from "app/services/quotation-history.service";
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PaginationService } from "app/services/pagination.service";
import * as _ from 'underscore';

@Component({
    selector: 'app-quotation-history-list',
    templateUrl: './quotation-history-list.component.html',
    styleUrls: ['./quotation-history-list.component.css']
})
export class QuotationHistoryListComponent implements OnInit {
    param_id: string;
    companny_key: string;
    quotation: any;
    length: any;
	pager: any = {};
	pagedItems: any[];
    private allItems: any;
    private allItemsOri: any;
    q: string = '';

    constructor(
        private quotationHistoryService: QuotationHistoryService,
        private router: Router,
        private route: ActivatedRoute,
        private paginationService: PaginationService
    ) { }

    ngOnInit() {
        this.companny_key = this.route.snapshot.params['comp_key'];
        this.param_id = this.route.snapshot.params['id'];
        // console.log(this.param_id);
        // console.log(this.companny_key);
        this.quotationHistoryService.getQuotationBasedOnCompany(this.companny_key).subscribe(data => {
            this.quotation = data.filter(quot => {
                return quot.uid == this.param_id && quot.status == 'sent'
            }).sort((a, b) => {
                if (a.updated_at == b.updated_at) {
                    return 0;
                }
                return a.updated_at > b.updated_at ? -1 : 1;
            });
            this.length = this.quotation.length;
            this.allItemsOri = _.clone(this.quotation);
            this.allItems = _.clone(this.quotation);
            this.setPage(1);
            console.log(this.length)
        })
    }

    goBack() {
        window.history.back();
    }

    setPage(page: number) {
        // get pager object from service
        this.pager = this.paginationService.getPager(this.allItems.length, page);

        // get current page of items
        this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

    filter_result() {
		if (this.q) {
			this.allItems = this.allItemsOri.filter(item => {
				var regex = new RegExp(this.escapeRegExp(this.q), 'gi');

				var name = regex.test(item.name);

				return name;
			})
		}
		else {
			this.allItems = this.allItemsOri;
		}

		this.setPage(1);
	}

	escapeRegExp(str) {
		return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}


}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/quotation/quotation-history-list/quotation-history-list.component.ts